import WorkflowRecentsPage from "src/views/products/workflow/pages/WorkflowRecentsPage";
import { PROPOSAL_GENERATION_PRODUCT } from "./proposalGenerationProduct";

const ProposalGenerationRecentsPage = () => (
  <WorkflowRecentsPage product={PROPOSAL_GENERATION_PRODUCT} />
);

export default ProposalGenerationRecentsPage;
